import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { LayoutState } from '../types/layout-state.type';

export const layoutSelector = ({ layout }: DefaultRootState) => layout;

export const hasILRImageSelector = createSelector(
  layoutSelector,
  ({ ilrImage }) => ilrImage.hasImage,
);

export const ILRImageLoadedSelector = createSelector(
  layoutSelector,
  ({ ilrImage }) => ilrImage.loaded,
);

export const showParentHRPlotSelector = createSelector(
  layoutSelector,
  ({ showParentHRPlot }) => showParentHRPlot,
);

export const getLayoutValueSelector = (layoutKey: keyof LayoutState) =>
  createSelector(layoutSelector, (layout) => layout[layoutKey]);

export const sortingStrategySelector = createSelector(
  layoutSelector,
  ({ sortingStrategy }) => sortingStrategy,
);

export const filterOptionSelector = createSelector(
  layoutSelector,
  ({ filterOption }) => filterOption,
);

export const gainSelector = createSelector(layoutSelector, ({ gain }) => gain);

export const displaySelector = createSelector(
  layoutSelector,
  ({ display }) => display,
);

export const showDelineationSelector = createSelector(
  layoutSelector,
  ({ showDelineation }) => showDelineation,
);

export const restingLeadSelector = createSelector(
  layoutSelector,
  ({ lead }) => lead,
);
